import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IEditGroupVisibilityByIDPayload } from '@app-store/slices/eventSettings/editGroupVisibilityByID'
import { notification } from 'antd'

interface TaskAction extends Action {
    payload: IEditGroupVisibilityByIDPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.eventSetting.editGroupVisibilityById

function* editGroupVisibilityByIdSagaTask({ payload }: TaskAction) {
    try {
        const response = yield axios.put(
            `/event/settings/${payload.settingId}/group-visibility/${payload.visibilityId}`,
            payload.data
        )
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Visibility setting updated successfully.'
            })
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editGroupVisibilityByIdSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editGroupVisibilityByIdSagaTask)
}

export default editGroupVisibilityByIdSaga
